import { DocumentData, Firestore, QuerySnapshot } from 'firebase/firestore';
import { typeUniqueId } from "../../../../dataObjects/types"
import { FirebaseAppSingleton } from "../../../cloudServices/googleFirebaseServices/FirebaseAppSingleton";
import { IFirestoreVideoLinkRepository_Ext, FirestoreVideoLinkRepository_Ext } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreVideoLinkRepository";


export function getVideoLinksForIds_onSnapshot(ids: Array<typeUniqueId>, callback: (snapshot: QuerySnapshot<DocumentData>) => void): Promise<Array<() => void>> {
  return new Promise<Array<() => void>>(async (resolve, reject) => {
    try {
      // initialize a Firestore object instance
      const firestoreObj: Firestore = FirebaseAppSingleton.firestore;

      const firestoreVideoLinkRepository_Ext: IFirestoreVideoLinkRepository_Ext = new FirestoreVideoLinkRepository_Ext(firestoreObj);

      // fetch the topics for the pertinent channelId
      const unsubscribeCallbacks: Array<() => void> = await firestoreVideoLinkRepository_Ext.getObjectsForIds_onSnapshot(ids, callback);

      resolve(unsubscribeCallbacks);
    }
    catch (error: any) {
      reject(error);
    }
  });
}